// Gerd wird 40: Übernachtungsgäste aus den Zusagen + ob sie schon einen Bungalow angefragt/gebucht haben (Zuordnung über die E-Mail)
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { BedDouble, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/gerd40/guestlist`;
const day = (iso) => (iso ? new Date(iso).toLocaleDateString("de-DE", { timeZone: "Europe/Berlin" }) : "");
const STATE = {
  gebucht: ["gebucht", "bg-emerald-500/15 text-emerald-300"],
  angefragt: ["angefragt", "bg-sky-500/15 text-sky-300"],
  abgelehnt: ["abgelehnt", "bg-rose-500/15 text-rose-300"],
  offen: ["noch offen", "bg-amber-500/15 text-amber-300"],
};
const FILTERS = ["alle", "offen", "angefragt", "gebucht", "abgelehnt"];

function Row({ r }) {
  const [label, cls] = STATE[r.state];
  return (
    <div className="py-2 grid grid-cols-[1fr_auto] sm:grid-cols-[1fr_90px_200px_110px] gap-2 items-center text-sm" data-testid={`gerd40-stay-row-${r.id}`}>
      <span className="min-w-0 truncate"><b>{r.name}</b>{r.email ? <span className="text-eb-muted text-xs"> · {r.email}</span> : <span className="text-amber-300/80 text-xs"> · keine E-Mail</span>}</span>
      <span className="hidden sm:block text-xs text-eb-muted">{r.persons} Pers.</span>
      <span className="hidden sm:block text-xs text-eb-muted truncate">
        {r.inquiry ? `Anfrage ${day(r.inquiry.created_at)} · ${r.inquiry.adults + (r.inquiry.children || 0)} Pers.` : `Zusage ${day(r.rsvp_at)}`}</span>
      <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full w-fit ${cls}`} data-testid={`gerd40-stay-state-${r.id}`}>{label}</span>
    </div>
  );
}

export function StayList() {
  const [d, setD] = useState(null);
  const [f, setF] = useState("alle");
  const load = useCallback(() => axios.get(API).then((r) => setD(r.data)).catch(() => setD({ rows: [], counts: {}, total: 0, persons: 0 })), []);
  useEffect(() => { load(); }, [load]);
  if (!d) return null;
  const rows = d.rows.filter((r) => f === "alle" || r.state === f);
  return (
    <div className="bg-eb-surface border border-white/5 rounded-xl p-5" data-testid="gerd40-staylist">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h3 className="font-heading font-semibold flex items-center gap-2"><BedDouble size={16} /> Übernachtungsgäste &amp; Bungalow</h3>
        <button onClick={load} data-testid="gerd40-stay-reload" className="flex items-center gap-2 text-xs px-3 py-1.5 rounded-md border border-white/10 hover:bg-white/5"><RefreshCw size={13} /> Aktualisieren</button>
      </div>
      <p className="text-sm mt-2" data-testid="gerd40-stay-summary">
        <b>{d.total}</b> Übernachtungsgäste ({d.persons} Pers.): <span className="text-emerald-300">{d.counts.gebucht || 0} gebucht</span> · <span className="text-sky-300">{d.counts.angefragt || 0} angefragt</span> · <span className="text-amber-300">{d.counts.offen || 0} noch offen</span>{d.counts.abgelehnt ? ` · ${d.counts.abgelehnt} abgelehnt` : ""}</p>
      <div className="flex gap-2 flex-wrap mt-3">
        {FILTERS.map((k) => (
          <button key={k} onClick={() => setF(k)} data-testid={`gerd40-stay-filter-${k}`}
            className={`text-xs px-3 py-1 rounded-full border transition-colors ${f === k ? "bg-white text-black border-white" : "border-white/10 hover:bg-white/5"}`}>
            {k === "alle" ? `Alle (${d.total})` : `${STATE[k][0]} (${d.counts[k] || 0})`}</button>
        ))}
      </div>
      {d.total === 0 ? <p className="text-xs text-eb-muted mt-3" data-testid="gerd40-stay-empty">Noch keine Zusagen mit Übernachtung.</p> : (
        <div className="mt-2 divide-y divide-white/5" data-testid="gerd40-stay-rows">{rows.map((r) => <Row key={r.id} r={r} />)}</div>
      )}
      <p className="text-[11px] text-eb-muted mt-3">Zuordnung über die E-Mail aus Zusage und Bungalow-Anfrage. „Gebucht“ = Anfrage unten auf „gebucht“ gesetzt. Online-Buchungen über easybooking sieht Sunworker nicht.</p>
    </div>
  );
}
